<template>
  <v-select
    :value="value"
    :items="items"
    :loading="loading"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'FunctionItemsSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    selectItemsFunction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      items: [],
      loading: false
    }
  },
  watch: {
    selectItemsFunction: {
      immediate: true,
      handler () {
        this.loadItems()
      }
    }
  },
  methods: {
    async loadItems () {
      if (!this.selectItemsFunction) return

      try {
        this.loading = true

        // Call the function, which could be synchronous or asynchronous
        const result = this.selectItemsFunction()

        // Handle both Promise and direct return
        if (result instanceof Promise) {
          this.items = await result
        } else {
          this.items = result
        }
      } catch (error) {
        console.error('Error loading items:', error)
        this.items = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
